// extracted by mini-css-extract-plugin
module.exports = {"sans":"fonts_sans__ckxS7","serif":"fonts_serif__WxJal","numbers":"fonts_numbers__kU7l_"};